import React, { useState } from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, mobileHero, mobileHeroText, viewMenuButton } from 'images'
import ViewMenu from './ViewMenu'
import MenuModal from './MenuModal'
import ReserveButton from './ReserveButton'

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="105VH"
          w="100%"
          image={`url(${mobileHero}) top / cover no-repeat`}
          boxShadow="0 2px 2px rgba(0,0,0,.5)"
          column
          justifyBetween
          alignCenter
        >
          <CFImage src={mobileHeroText} w="60%" alt="Promotions" mt="15px" />
          <CFView bg="rgba(0,0,0,.8)" pt="15px" w="100%" textCenter>
            <CFView pulsate>
              <OrderPickupButton />
            </CFView>
            <CFView h4 xBold hover onClick={() => setShowModal(true)}>
              <CFImage src={viewMenuButton} maxWidth="240px" mt="10px" />
            </CFView>
            <CFView mt="8px">
              <ReserveButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="95vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) top/ cover no-repeat`}
          zIndex={90}
          column
          justifyBetween
          alignCenter
          boxShadow="0 2px 2px rgba(0,0,0,.5)"
        >
          <Header />
          <CFView
            row
            center
            alignCenter
            w="100%"
            maxWidth="800px"
            bg="rgba(0,0,0,.8)"
            pt="5px"
          >
            {/* <CFView column justifyStart>
              <CFText hero raleway white xBold style={{ fontSize: 30 }}>
                NOW TAKING ONLINE ORDERS
              </CFText>
            </CFView> */}
            <CFView pulsate>
              <OrderPickupButton />
            </CFView>
            <CFView ml="25px">
              <ReserveButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
      <MenuModal
        showModal={showModal}
        onRequestClose={() => setShowModal(false)}
      />
    </CFView>
  )
}
